import script from "./stone.vue?vue&type=script&setup=true&lang=js"
export * from "./stone.vue?vue&type=script&setup=true&lang=js"

import "./stone.vue?vue&type=style&index=0&id=61c69362&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c69362"]])

export default __exports__